// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DeviceDetailsLine__container-c309d0 {
  --meta-block-actions-background: var(--base-10);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/Device/DeviceDetails/DeviceDetailsLine/DeviceDetailsLine.styles.m.css"],"names":[],"mappings":"AAAA;EACE,+CAAA;AACF","sourcesContent":[".container {\n  --meta-block-actions-background: var(--base-10);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DeviceDetailsLine__container-c309d0`
};
module.exports = ___CSS_LOADER_EXPORT___;
